/**
 * Shared cart utility functions used across quick-add components and sticky ATC bar.
 */
const CartUtils = {
  async addToCartAndOpen(bodyData) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) throw new Error('cart-drawer element not found.');

    const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);

    const response = await fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        ...bodyData,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();
    if (data.status) {
      throw Object.assign(
        new Error(data.description || data.message || 'Add to cart failed'),
        { cartResponse: data }
      );
    }

    cartDrawer.renderContents(data);
    cartDrawer.classList.remove('is-empty');
    return data;
  },
};
